// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__OJfP6","colCheckbox":"styles_colCheckbox__3Cp2g"};